export const MenuItems = [
    {
        title: 'פרטים אישיים',
        url:'/home',
        cName: 'nav-links'
    },
    {
        title: 'פרטי הקורסים',
        url:'/courses_info',
        cName: 'nav-links'
    },
    {
        title: 'דירוג הקורסים',
        url:'/ranking',
        cName: 'nav-links'
    },
    {
        title: 'תוצאות',
        url:'/results',
        cName: 'nav-links'
    },
    {
        title: 'משוב',
        url:'/feedback',
        cName: 'nav-links'
    },

]